webpackJsonp([75213880504026],{

/***/ 73:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _gatsbyLink = __webpack_require__(20);
	
	var _gatsbyLink2 = _interopRequireDefault(_gatsbyLink);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var Code = function Code(_ref) {
	    var code = _ref.code;
	    return _react2.default.createElement(
	        'p',
	        { className: 'code' },
	        code
	    );
	};
	
	exports.default = Code;
	module.exports = exports['default'];

/***/ }),

/***/ 199:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _gatsbyLink = __webpack_require__(20);
	
	var _gatsbyLink2 = _interopRequireDefault(_gatsbyLink);
	
	var _syntax = __webpack_require__(73);
	
	var _syntax2 = _interopRequireDefault(_syntax);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var CheatSheet = function CheatSheet() {
	  return _react2.default.createElement(
	    'div',
	    null,
	    _react2.default.createElement(
	      'h2',
	      null,
	      'Create \xA0',
	      _react2.default.createElement('i', { className: 'em em-sparkles' })
	    ),
	    _react2.default.createElement(
	      'p',
	      null,
	      'Clone an existing repository',
	      _react2.default.createElement(_syntax2.default, { code: '$ git clone ssh://userdomain.com/repo.git' })
	    ),
	    _react2.default.createElement(
	      'p',
	      null,
	      'Create a new local repository',
	      _react2.default.createElement(_syntax2.default, { code: '$ git init' })
	    ),
	    _react2.default.createElement(
	      'h2',
	      null,
	      'Local Changes \xA0',
	      _react2.default.createElement('i', { className: 'em em-house_with_garden' })
	    ),
	    _react2.default.createElement(
	      'p',
	      null,
	      'View changed files in working directory',
	      _react2.default.createElement(_syntax2.default, { code: '$ git status' })
	    ),
	    _react2.default.createElement(
	      'p',
	      null,
	      'Add all current changes to next commit',
	      _react2.default.createElement(_syntax2.default, { code: '$ git add .' })
	    ),
	    _react2.default.createElement(
	      'p',
	      null,
	      'Add some changes to next commit',
	      _react2.default.createElement(_syntax2.default, { code: '$ git add -p <file>' })
	    ),
	    _react2.default.createElement(
	      'p',
	      null,
	      'Commit previously staged changes with message',
	      _react2.default.createElement(_syntax2.default, { code: '$ git commit -m \'message\'' })
	    ),
	    _react2.default.createElement(
	      'h2',
	      null,
	      'Commit history \xA0',
	      _react2.default.createElement('i', { className: 'em em-book' })
	    ),
	    _react2.default.createElement(
	      'p',
	      null,
	      'Show all commits, starting with newest',
	      _react2.default.createElement(_syntax2.default, { code: '$ git log' })
	    ),
	    _react2.default.createElement(
	      'p',
	      null,
	      'Who changed what and when in a file',
	      _react2.default.createElement(_syntax2.default, { code: '$ git blame <file>' })
	    ),
	    _react2.default.createElement(
	      'h2',
	      null,
	      'Branches and tags \xA0',
	      _react2.default.createElement('i', { className: 'em em-palm_tree' })
	    ),
	    _react2.default.createElement(
	      'p',
	      null,
	      'List all existing branches',
	      _react2.default.createElement(_syntax2.default, { code: '$ git branch -av' })
	    ),
	    _react2.default.createElement(
	      'p',
	      null,
	      'Switch HEAD branch',
	      _react2.default.createElement(_syntax2.default, { code: '$ git checkout <branch>' })
	    ),
	    _react2.default.createElement(
	      'h2',
	      null,
	      'Update and publish \xA0',
	      _react2.default.createElement('i', { className: 'em em-lower_left_fountain_pen' })
	    ),
	    _react2.default.createElement(
	      'p',
	      null,
	      'List all currently configured remotes',
	      _react2.default.createElement(_syntax2.default, { code: '$ git remote -v' })
	    ),
	    _react2.default.createElement(
	      'p',
	      null,
	      'Download changes and merge into HEAD',
	      _react2.default.createElement(_syntax2.default, { code: '$ git pull <remote> <branch>' })
	    ),
	    _react2.default.createElement(
	      'p',
	      null,
	      'Publish local changes on a remote',
	      _react2.default.createElement(_syntax2.default, { code: '$ git push <remote> <branch>' })
	    ),
	    _react2.default.createElement(
	      'h2',
	      null,
	      'Merge and rebase \xA0',
	      _react2.default.createElement('i', { className: 'em em-raised_hands' })
	    ),
	    _react2.default.createElement(
	      'p',
	      null,
	      'Merge branch into your current HEAD',
	      _react2.default.createElement(_syntax2.default, { code: '$ git remote -v' })
	    ),
	    _react2.default.createElement(
	      'p',
	      null,
	      'Rebase your current HEAD onto branch (not for published commits)',
	      _react2.default.createElement(_syntax2.default, { code: '$ git rebase <branch>' })
	    ),
	    _react2.default.createElement(
	      'h2',
	      null,
	      'Undo \xA0',
	      _react2.default.createElement('i', { className: 'em em-rewind' })
	    ),
	    _react2.default.createElement(
	      'p',
	      null,
	      'Discard all local changes in working directory',
	      _react2.default.createElement(_syntax2.default, { code: '$ git reset --hard HEAD' })
	    ),
	    _react2.default.createElement(
	      'p',
	      null,
	      'Discard local changes in a specific file',
	      _react2.default.createElement(_syntax2.default, { code: '$ git checkout HEAD <file>' })
	    ),
	    _react2.default.createElement(
	      'p',
	      null,
	      'Revert a commit',
	      _react2.default.createElement(_syntax2.default, { code: '$ git revert <commit>' })
	    ),
	    _react2.default.createElement(
	      'h2',
	      null,
	      'Setting up profile '
	    ),
	    _react2.default.createElement(
	      'p',
	      null,
	      'Using username',
	      _react2.default.createElement(_syntax2.default, { code: '$ git config --global user.name \\\'YOUR_USERNAME\\\'' })
	    ),
	    _react2.default.createElement(
	      'p',
	      null,
	      'Using email',
	      _react2.default.createElement(_syntax2.default, { code: '$ git config --global user.email YOUR_EMAIL_HERE' })
	    ),
	    _react2.default.createElement(
	      'p',
	      null,
	      'Checking you config settings',
	      _react2.default.createElement(_syntax2.default, { code: '$ git config --list' })
	    )
	  );
	};
	
	exports.default = CheatSheet;
	module.exports = exports['default'];

/***/ })

});


// WEBPACK FOOTER //
// component---src-pages-cheatsheet-js-c192be62a086b5154629.js